<template>
  <div>
    <div class="alert alert-danger" v-if="errorMsg">{{ errorMsg }}</div>

    <div class="row mb-2">
      <div class="col-auto">
        <button class="btn btn-primary gdq_faded gdq-font-size-80" @click="addNew">
          <span class="icon-plus mr-1"></span>Add knowledge entry
        </button>
      </div>
    </div>

    <div class="card mb-3" v-if="showForm">
      <div class="card-body">
        <h6 class="card-title">{{ editing.id > 0 ? 'Edit knowledge entry' : 'New knowledge entry' }}</h6>
        <div class="mb-3 d-flex align-items-center">
          <label class="col-form-label" style="width: 200px; flex-shrink: 0">Keywords (comma-separated)</label>
          <div style="flex: 1"><input class="form-control" v-model="editing.keywords" placeholder="invoice, payment, faktura" /></div>
        </div>
        <div class="mb-3">
          <label class="col-form-label d-block mb-2">Answer (HTML)</label>
          <VueEditor v-model="editing.answer" />
        </div>
        <div class="mb-3 d-flex align-items-center">
          <label class="col-form-label" style="width: 200px; flex-shrink: 0">Suggested question chips (comma-separated)</label>
          <div style="flex: 1"><input class="form-control" v-model="editing.chips" /></div>
        </div>
        <div>
          <button class="btn btn-outline-secondary" @click="cancel">Cancel</button>
          <button class="btn btn-primary float-end" :disabled="saving" @click="save">
            <fa-icon name="check" />Save
          </button>
        </div>
      </div>
    </div>

    <table class="table table-hover lh-table">
      <thead>
        <tr>
          <th style="width: 40px;">ID</th>
          <th>Keywords</th>
          <th>Answer</th>
          <th>Chips</th>
          <th style="width: 70px;">⚡</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in rows" :key="item.id" style="cursor: pointer;" @click="editRow(item)">
          <td>{{ item.id }}</td>
          <td>{{ item.keywords }}</td>
          <td class="text-muted">{{ plain(item.answer) }}</td>
          <td>{{ item.chips || '-' }}</td>
          <td>
            <span style="cursor: pointer;" title="Delete" @click.prevent.stop="delRow(item)">
              <fa-icon name="trash-alt" />
            </span>
          </td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="5" class="text-center text-muted py-3">No knowledge entries</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import VueEditor from '../CustomControls/VueEditor.vue'

export default {
  name: 'LHCourseSueKb',
  components: { VueEditor },
  props: {
    courseId: { type: Number, required: true },
    rows: { type: Array, required: true }
  },
  data () {
    return {
      showForm: false,
      saving: false,
      errorMsg: '',
      editing: this.emptyRow()
    }
  },
  methods: {
    emptyRow () {
      return { id: 0, keywords: '', answer: '', chips: '' }
    },
    plain (html) {
      return String(html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim().substring(0, 120)
    },
    addNew () {
      this.errorMsg = ''
      this.editing = this.emptyRow()
      this.showForm = true
    },
    editRow (r) {
      this.errorMsg = ''
      this.editing = { ...r }
      this.showForm = true
    },
    cancel () {
      this.showForm = false
    },
    async save () {
      this.saving = true
      this.errorMsg = ''
      try {
        const body = {
          keywords: this.editing.keywords,
          answer: this.editing.answer,
          chips: this.editing.chips
        }
        if (this.editing.id > 0) {
          await this.$store.dispatch('learninghub_sue_kb_update', { id: this.editing.id, body })
        } else {
          body.course_id = this.courseId
          await this.$store.dispatch('learninghub_sue_kb_save', { body })
        }
        this.showForm = false
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Save failed')
      }
      this.saving = false
    },
    async delRow (r) {
      if (!confirm('Delete knowledge entry (keywords: ' + r.keywords + ')?')) return
      try {
        await this.$store.dispatch('learninghub_sue_kb_delete', { id: r.id })
        this.$emit('changed')
      } catch (e) {
        this.errorMsg = e.response && e.response.data && typeof e.response.data.result === 'string'
          ? e.response.data.result : (e.message || 'Delete failed')
      }
    }
  }
}
</script>

<style>
.lh-table {
  font-size: 0.9rem !important;
}
</style>
